<template>
  <div class="item-base">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "UserBase"
}
</script>

<style scoped>
.item-base {
  height: 92vh;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 10px;
  padding: 10px;
}
</style>